module.exports = __webpack_public_path__ + "static/media/education.c29505de.jpg";